import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'action-search-dialog',
    templateUrl: './action-search-dialog.component.html',
    providers: [DataService]
})
export class ActionSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'IntegrationActionConfig';
        this.model.title = 'Select Action';

        this.model.criteria.Max = this.model.currentOptions.maxRows;
        this.model.criteria.Disabled_Ind = 'N';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
